export default __webpack_public_path__ + "static/media/email.e0897d65.png";